import { Modal, Row, Upload, message } from 'antd';
import React, { useState, useEffect } from 'react';
import EditableAvatar from './EditableAvatar';
import { useIntl } from 'react-intl';

const UploadPfpModal = (props) => {
  const { currentValue, visible, onOk, onCancel, title } = props;
  const [previewSrc, setPreviewSrc] = useState(currentValue);
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (visible) {
      setPreviewSrc(currentValue);
      setFileList([]);
    }
  }, [visible, currentValue]);

  const handleUploadChange = (info) => {
    setFileList(info.fileList);

    if (info.fileList[0]?.originFileObj) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewSrc(e.target.result);
      };
      reader.readAsDataURL(info.fileList[0].originFileObj);
    }
  };

  const handleOk = () => {
    if (fileList.length === 0) {
      message.warning(intl.formatMessage({ id: 'profile.edit-profile.selectImage' }));
      return;
    }

    const file = fileList[0].originFileObj;
    onOk(file);
  };

  const handleCancel = () => {
    setPreviewSrc(currentValue);
    setFileList([]);
    onCancel();
  };
  const intl = useIntl();
  return (
    <Modal
      title={title}
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      okText={intl.formatMessage({ id: 'profile.edit-profile.confirm-button' })}
    >
      <Row
        style={{
          display: 'flex',
          justifyContent: 'center'
        }}
      >
        <Upload
          beforeUpload={() => false}
          onChange={handleUploadChange}
          showUploadList={false}
          accept='image/*'
          maxCount={1}
          fileList={fileList}
        >
          <EditableAvatar src={previewSrc} variant='opaque' showText />
        </Upload>
      </Row>
    </Modal>
  );
};

export default UploadPfpModal;
